// src/pages/PahijeHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const PahijeHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("About");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Home", emoji: "🏠" },
    { label: "Recruiters", emoji: "🧑‍💼" }, 
    { label: "Job Seekers", emoji: "🧑‍🎓" },      
    { label: "ORS", emoji: "📄" },
    { label: "Communication. Interviews.", emoji: "🤝" },
    { label: "Candidate Scan", emoji: "🧪" },
    { label: "Orientation", emoji: "🧭" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "PehchaanSetu", emoji: "🌉" },
    { label: "Digital Side Hussle", emoji: "💸" },
    { label: "Pahije Games", emoji: "🎮" },
  ];

  const menuButtons1 = [
    // 🏠 Home
    { label: "About Pahije", emoji: "ℹ️", link: "/pahije-about", group: "Home" },
    { label: "jobsTube", emoji: "📺", link: "/msmetube", group: "Home" },
    { label: "Jobs Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Home" },
    { label: "Free Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Home" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Home" },
    { label: "Job MetaVerse", emoji: "🕶️", link: "", group: "Home" },
    { label: "Job Forum", emoji: "🗣️", link: "/povify-home", group: "Home" },
    { label: "Settings", emoji: "⚙️", link: "", group: "Home" },

    // 🧑‍💼 Recruiters
    { label: "JD", emoji: "📄", link: "", group: "Recruiters" },                 
    { label: "Campaigns", emoji: "📢", link: "", group: "Recruiters" },          
    { label: "Shortlist Resume", emoji: "✅", link: "", group: "Recruiters" },   
    { label: "Upload Resume", emoji: "📤", link: "", group: "Recruiters" },       
    { label: "Activity Dashboard", emoji: "📊", link: "", group: "Recruiters" },  
    { label: "Leaderboard", emoji: "🏆", link: "", group: "Recruiters" },         
    { label: "AI Settings", emoji: "🤖", link: "", group: "Recruiters" },         
    { label: "My Candidates", emoji: "👥", link: "", group: "Recruiters" },       

    // 🧑‍🎓 Job Seekers
    { label: "Shortlist Jobs", emoji: "📌", link: "", group: "Job Seekers" },   
    { label: "Immersive Books", emoji: "📚", link: "/pahije-bookworld", group: "Job Seekers" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Job Seekers" },
    { label: "My Applications", emoji: "📨", link: "", group: "Job Seekers" },    
    { label: "My Results", emoji: "🏆", link: "", group: "Job Seekers" },          
    { label: "My Profile", emoji: "👤", link: "", group: "Job Seekers" },    
    { label: "My Multimedia Profile", emoji: "👤", link: "", group: "Job Seekers" },    
    { label: "My Voice Samples", emoji: "🎙️", link: "", group: "Job Seekers" },   
    { label: "AI Settings", emoji: "🤖", link: "", group: "Job Seekers" },        
    { label: "My Digital Card", emoji: "💼", link: "/pahije-digitalcard", group: "Job Seekers" },
    { label: "My Speaking Card", emoji: "🎤", link: "/contact-genious-speakingcard", group: "Job Seekers" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "Job Seekers" },

    // 📄 ORS
    { label: "Open Resume System", emoji: "📄", link: "/pahije-ors", group: "ORS" },

    // 🤝 Communication. Interviews.
    { label: "Interview Calendar", emoji: "🗓️", link: "/calendar-list", group: "Communication. Interviews." },
    { label: "Visits for Interview", emoji: "📍", link: "/visits-list", group: "Communication. Interviews." },
    { label: "Interview Thoughts", emoji: "💭", link: "/thoughts-list", group: "Communication. Interviews." },
    { label: "Interview TODO", emoji: "✅", link: "/todo-list", group: "Communication. Interviews." },
    { label: "Interview Tasks", emoji: "🛠️", link: "/tasks-list", group: "Communication. Interviews." },
    { label: "Travelling for Interviews", emoji: "🚆", link: "/travels-list", group: "Communication. Interviews." },
    { label: "Interview Checklist", emoji: "📋", link: "/checklist-list", group: "Communication. Interviews." },
    { label: "Interview Record", emoji: "🗂️", link: "/meetings-list", group: "Communication. Interviews." },
    { label: "Interview Analytics AI", emoji: "🧠📈", link: "", group: "Communication. Interviews." },

    // 🧪 Candidate Scan
    { label: "Oral Interview", emoji: "🗣️", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "Candidate Practice", emoji: "🏋️‍♂️", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "MCQ Mock Test", emoji: "📝", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "Short Answers Mock Test", emoji: "✍️", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "AI Mock Test", emoji: "🤖", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "Think5Whys Certificate", emoji: "🎓", link: "/pahije-ors", group: "Candidate Scan" },
    { label: "Handwrittem Test", emoji: "✍️📄", link: "/pahije-ors", group: "Candidate Scan" },

    // 🧭 Orientation
    { label: "Job Kit", emoji: "🧰", link: "", group: "Orientation" },
    { label: "Learning", emoji: "📘", link: "/pahije-bookworld", group: "Orientation" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Orientation" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Orientation" },
    { label: "Onboarding", emoji: "🚀", link: "", group: "Orientation" },
    { label: "KRA-KPI", emoji: "🎯", link: "", group: "Orientation" },
    { label: "AI for Candidates", emoji: "🤖👨‍💼", link: "/agenticsim", group: "Orientation" },

    // 💰 Digital Side Hussle
    { label: "Monthly Side Hussle", emoji: "💻🌱", link: "/pahije-bookworld", group: "Digital Side Hussle" },
    { label: "Kharcho Jeeto", emoji: "💰🎉", link: "/kharchojeeto", group: "Digital Side Hussle" },
    { label: "Referral Income", emoji: "🔗💸", link: "/orderflow-earning-estimator", group: "Digital Side Hussle" },
    { label: "Resell", emoji: "♻️🛒", link: "/pahije-enroll", group: "Digital Side Hussle" },
    { label: "Rewarding Ads", emoji: "📢🎁", link: "/visigift-home", group: "Digital Side Hussle" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Side Hussle" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Side Hussle" },

    // 🪞 Self Reflection
    { label: "Personal Digital Card", emoji: "📇", link: "/pahije-digitalcard", group: "Self Reflection" },
    { label: "Self Management", emoji: "🧘‍♂️", link: "/pahije-self-chronicles", group: "Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/pahije-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Self Reflection" },
    { label: "My Limit", emoji: "📏", link: "/mylimit", group: "Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🤖🧑‍⚕️", link: "/aicounselling", group: "Self Reflection" },
    { label: "Candidate Productivity Suite", emoji: "🧠⚙️", link: "", group: "Self Reflection" },

    // 🌉 PehchaanSetu
    { label: "PehchaanSetu", emoji: "🌉", link: "/pehchaansetu", group: "PehchaanSetu" },

    // 🎮 Pahije Games
    { label: "Remembering Games", emoji: "🧠", link: "", group: "Pahije Games" },
    { label: "Understand Games", emoji: "💡", link: "", group: "Pahije Games" },
    { label: "Applying Games", emoji: "🎯", link: "", group: "Pahije Games" },
    { label: "Analyzing Games", emoji: "🔍", link: "", group: "Pahije Games" },
    { label: "Evaluating Games", emoji: "⚖️", link: "", group: "Pahije Games" },
    { label: "Creating Abilities Games", emoji: "🛠️✨", link: "r", group: "Pahije Games" },
    { label: "AI Skills Games", emoji: "🤖", link: "", group: "Pahije Games" },
    { label: "Digital Skills Games", emoji: "💻", link: "", group: "Pahije Games" },
    { label: "Social Skills Games", emoji: "🗣️👥", link: "", group: "Pahije Games" },
    { label: "Self Reflection Games", emoji: "🪞", link: "", group: "Pahije Games" },


  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">🥽 Think5Whys Pahije</div>
          <div className="text-[11px] text-gray-200">Not Just Jobs — Better Decisions!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      {/* <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          <a href="/Pahije-whysakshamPahije" className="hover:text-yellow-200">💭 About</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Pahije News</Link>
          <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
          <a href="/growsure" className="hover:text-yellow-200">💪 PMMY</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <a href="/Pahije-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div> */}

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PahijeHome;
